module.exports = __webpack_public_path__ + "../resources/graphql/schema.all.min-a1457a5d0beb571b4c94af7f69d94e41.graphql";